import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';

@Component({
  selector: 'app-bussiness-unit-master',
  templateUrl: './bussiness-unit-master.component.html',
  styleUrls: ['./bussiness-unit-master.component.scss']
})

export class BussinessUnitMasterComponent implements OnInit {
  date: any;
  submitButton: string = 'Submit'
  BussinessUnitNumberTable: any = [];
  myDate: any;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(private _apiService: ApiServiceService, private _utility: AppUtility , private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.getAllTableData();
  }

  breadcrumb = [
    {
      title: 'BussinessUnitNumber List',
      subTitle: 'Dashboard'
    }
  ]

  BussinessUnitNumberProcessForm = new FormGroup({
    BussinessName: new FormControl('', [Validators.required]),
    isCustomer : new FormControl(false , [Validators.required])
  })

  BussinessUnitNumberProcessFormSubmit(BussinessUnitNumber: FormGroupDirective) {
    console.log(this.BussinessUnitNumberProcessForm.value);
    if (this.BussinessUnitNumberProcessForm.valid) {
      this._utility.loader(true);
      let object = this.BussinessUnitNumberProcessForm.value;
      if (this.submitButton == 'Submit') {
        this._apiService.AddbussinessUnitNumber(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.BussinessUnitNumberProcessForm.reset();
            // ;          
            Object.keys(this.BussinessUnitNumberProcessForm.controls).forEach(key => {
              this.BussinessUnitNumberProcessForm.controls[key].setErrors(null)
            });
            BussinessUnitNumber.resetForm();
          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }
          this.getAllTableData();
        })
      }
      else {
        object['BussinessUnitNumberId'] = this.editItemId;
        console.log(object);
        this._apiService.editBussinessUnitNumber(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.BussinessUnitNumberProcessForm.reset();
            Object.keys(this.BussinessUnitNumberProcessForm.controls).forEach(key => {
              this.BussinessUnitNumberProcessForm.controls[key].setErrors(null)
            });
            BussinessUnitNumber.resetForm();
            this.submitButton = 'Submit'
            this.getAllTableData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }

  editItemId: any;
  EditItem(customer: any) {
    if (customer.id) {
      this.BussinessUnitNumberProcessForm.controls['BussinessName'].setValue(customer['value']);
      // Object.keys(this.BussinessUnitNumberProcessForm.controls).forEach(key => {
      //   this.BussinessUnitNumberProcessForm.controls[key].setValue(customer[key]);
      // });
      this.submitButton = 'Update'
      this.editItemId = customer.id;
    }
  }

  getAllTableData() {
    this._utility.loader(true);
    this._apiService.dropdowndata('BussinessUnitNumber')
      .then((res: any) => {
        console.log(res);
        this._utility.loader(false);
        if (res.success == true) {
          this.BussinessUnitNumberTable = res.returnValue;
        }
        else {
          this.BussinessUnitNumberTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.BussinessUnitNumberTable = [];
      })
  }

  confirm1(costBreakupId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete BussinessUnitNumber Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(costBreakupId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(id: any) {
    this._utility.loader(true);
    this._apiService.deleteBussinessUnitNumber(id)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getAllTableData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getAllTableData();
      }

    })
  }
}